export default __webpack_public_path__ + "static/media/IMG_084_r.9785786e.jpg";